export default "__VITE_ASSET__DiYyKDTc__"